export default "__VITE_ASSET__fa5ec841__"